<template>
    <v-container fluid class="pa-0">
        <v-card>
            <v-card-title primary-title>
                <v-row>
                    <v-col> Registries </v-col>
                    <v-spacer />
                    <v-col class="text-right" v-if="userCanManageRegistrySchema">
                        <v-btn color="primary" @click="showCreateRegistrySchemaForm"
                            >Create Schema</v-btn
                        >
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <registries-list :registry-schemas="registrySchemas" :search="search" />
            </v-card-text>

            <v-dialog v-model="createRegistrySchemaDialogVisible">
                <registry-schema-form
                    @cancelForm="closeCreateRegistrySchemaForm"
                    @registrySchemaSaved="savedRegistrySchema"
                />
            </v-dialog>
        </v-card>
    </v-container>
</template>
<script>
import { defineComponent } from "vue";

import RegistriesList from "@/components/Registries/RegistriesList.vue";
import RegistrySchemaForm from "@/components/Registries/RegistrySchemaForm.vue";
import { withLoadingScreen } from "@/lib/loading.js";
import { mapGetters } from "vuex";
import { registriesAPI } from "@/services/registries/registriesAPI";

export default defineComponent({
    components: { RegistrySchemaForm, RegistriesList },
    data: function () {
        return {
            createRegistrySchemaDialogVisible: false,
            registrySchemas: [],
        };
    },
    props: {
        search: {
            type: String,
        },
    },
    async mounted() {
        await this.reloadRegistrySchemas();
    },
    computed: {
        ...mapGetters(["isAuthorized"]),
        userCanManageRegistrySchema() {
            return this.isAuthorized("Registries:Manage Schema");
        },
    },
    methods: {
        async reloadRegistrySchemas() {
            await withLoadingScreen(async () => {
                this.registrySchemas = await registriesAPI.fetchAllRegistrySchemas();
            });
        },
        showCreateRegistrySchemaForm() {
            this.createRegistrySchemaDialogVisible = true;
        },
        closeCreateRegistrySchemaForm() {
            this.createRegistrySchemaDialogVisible = false;
        },
        async savedRegistrySchema(savedSchema) {
            await withLoadingScreen(async () => {
                this.closeCreateRegistrySchemaForm();
                this.$router.push({ path: `/registries/view/${savedSchema.name}` });
            });
        },
    },
});
</script>
